import React from "react";
import InputField from "components/ui/forms/InputField";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

const PromoCode = () => {
  const { t } = useTranslation();
  const { control } = useForm({});

  return (
    <div className="md:flex  gap-2 md:p-3 py-3 md:bg-white/5 rounded">
      <InputField
        spacing="m-0"
        className="md:w-[60%] w-full"
        inputClassName="bg-white bg-opacity-[.15]"
        control={control}
        name="promoCode"
        label={t("Promo code")}
      />
      <button type="button" className="text-[12px] md:max-w-32 w-full py-2 md:mt-0 mt-7 px-4 text-white/30 bg-white bg-opacity-10 rounded" disabled>
        APPLY
      </button>
    </div>
  );
};

export default PromoCode;
